// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-engine-script.json
export class HrPayEngineScriptKey {
    private static readonly keyPrefix = 'hrPayEngineScript';
    public static pageHeader = `${HrPayEngineScriptKey.keyPrefix}.pageHeader`;
    public static content = `${HrPayEngineScriptKey.keyPrefix}.content`;
    public static payrollType = `${HrPayEngineScriptKey.keyPrefix}.payrollType`;
    public static type = `${HrPayEngineScriptKey.keyPrefix}.type`;
    public static schemaCode = `${HrPayEngineScriptKey.keyPrefix}.schemaCode`;
}
